import { Box, Typography, CircularProgress, Paper, useTheme, useMediaQuery } from "@mui/material"
import { useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useAuthService } from "../../../../use-cases/auth"
import { useAppDispatch } from "../../../hooks/store-hooks"
import { setTokenState } from "../../../../application/states/auth"

export const LoginPage = () => {
  const [message, setMessage] = useState("Processando autenticação...")
  const hasExecutedValidation = useRef(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.down('md'))

  const { setupSession } = useAuthService()
  const baseURLVelesLogin = String(process.env.REACT_APP_VELES_LOGIN_BASE_URL)

  useEffect(() => {
    if (hasExecutedValidation.current) return
    hasExecutedValidation.current = true

    const validateAndLogin = async () => {
      try {
        const params = new URLSearchParams(window.location.search)
        const token = params.get("token")

        if (!token) {
          let loginUrl = baseURLVelesLogin
          if (!loginUrl.includes('/authentication/login')) {
            loginUrl = loginUrl.replace('/auth/login', '/authentication/login')
          }
    
          window.location.href = `${loginUrl}?logout=true`
          return
        }

        // Limpa a URL do histórico
        window.history.replaceState({}, document.title, window.location.pathname)

        // Salva o token e timestamp no localStorage e no Redux
        const decodedToken = decodeURIComponent(token)
        localStorage.setItem('ACCESS_TOKEN', decodedToken)
        localStorage.setItem('LOGIN_TIMESTAMP', String(Date.now()))
        dispatch(setTokenState(decodedToken))

        // Restaura a sessão do usuário
        await setupSession()
        
        setMessage("Autenticado com sucesso! Entrando...")
        setTimeout(() => {
          navigate("/", { replace: true })
        }, 3000)

      } catch (error) {
        console.error("Erro na validação do token no Geo:", error)
        window.location.href = baseURLVelesLogin
      }
    }

    validateAndLogin()
  }, [setupSession, navigate, dispatch, baseURLVelesLogin])

  return (
    <Box 
      sx={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        overflow: 'hidden'
      }}
    >
      <Paper 
        elevation={10}
        sx={{ 
          p: 6, 
          borderRadius: 4, 
          textAlign: 'center',
          maxWidth: 450,
          width: '90%',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          animation: 'fadeIn 0.8s ease-out'
        }}
      >
        <Box sx={{ mb: 4 }}>
          <img 
            src="/logo_veles.png" 
            alt="Veles Logo" 
            style={{ 
              width: isSm ? '160px' : '220px', 
              marginBottom: theme.spacing(2),
              filter: 'drop-shadow(0px 4px 6px rgba(0,0,0,0.1))'
            }} 
          />
        </Box>
        
        <Box sx={{ position: 'relative', display: 'inline-flex', mb: 3 }}>
          <CircularProgress size={50} thickness={4} />
        </Box>

        <Typography 
          variant="h6" 
          fontWeight={600} 
          sx={{ color: theme.palette.text.primary, mb: 1 }}
        >
          {message}
        </Typography>
        
        <Typography variant="body2" color="text.secondary">
         Sistema de Identificação Inteligente
        </Typography>
      </Paper>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </Box>
  )
}